module.exports = __webpack_public_path__ + "img/Cornerclub-Gambler-elder-scrolls-legends.a570256d.jpg";